import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["title", "aria-label"];
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = ["aria-label"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'CiStatusIcon',
    props: {
        variant: {},
        label: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_ctx.variant === 'running')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "ci-spinner",
                    title: _ctx.label,
                    role: "img",
                    "aria-label": _ctx.label
                }, null, 8, _hoisted_1))
                : (_ctx.variant === 'success')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        class: "ci-glyph",
                        viewBox: "0 0 16 16",
                        "aria-label": _ctx.label,
                        role: "img"
                    }, [
                        _createElementVNode("title", null, _toDisplayString(_ctx.label), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("circle", {
                            cx: "8",
                            cy: "8",
                            r: "8",
                            fill: "var(--ci-success)"
                        }, null, -1)),
                        _cache[1] || (_cache[1] = _createElementVNode("path", {
                            d: "M4.3 8.2 L7 10.9 L11.8 5.4",
                            fill: "none",
                            stroke: "#fff",
                            "stroke-width": "1.6",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        }, null, -1))
                    ], 8, _hoisted_2))
                    : (_ctx.variant === 'fail')
                        ? (_openBlock(), _createElementBlock("svg", {
                            key: 2,
                            class: "ci-glyph",
                            viewBox: "0 0 16 16",
                            "aria-label": _ctx.label,
                            role: "img"
                        }, [
                            _createElementVNode("title", null, _toDisplayString(_ctx.label), 1),
                            _cache[2] || (_cache[2] = _createElementVNode("circle", {
                                cx: "8",
                                cy: "8",
                                r: "8",
                                fill: "var(--ci-fail)"
                            }, null, -1)),
                            _cache[3] || (_cache[3] = _createElementVNode("path", {
                                d: "M5.3 5.3 L10.7 10.7 M10.7 5.3 L5.3 10.7",
                                fill: "none",
                                stroke: "#fff",
                                "stroke-width": "1.6",
                                "stroke-linecap": "round"
                            }, null, -1))
                        ], 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("svg", {
                            key: 3,
                            class: "ci-glyph",
                            viewBox: "0 0 16 16",
                            "aria-label": _ctx.label,
                            role: "img"
                        }, [
                            _createElementVNode("title", null, _toDisplayString(_ctx.label), 1),
                            _cache[4] || (_cache[4] = _createElementVNode("circle", {
                                cx: "8",
                                cy: "8",
                                r: "8",
                                fill: "var(--ci-neutral)"
                            }, null, -1)),
                            _cache[5] || (_cache[5] = _createElementVNode("path", {
                                d: "M4.8 8 L11.2 8",
                                fill: "none",
                                stroke: "#fff",
                                "stroke-width": "1.6",
                                "stroke-linecap": "round"
                            }, null, -1))
                        ], 8, _hoisted_4));
        };
    }
});
